import React from 'react';
import IconLinkedin from './IconLinkedin';
import IconGitHub from './IconGitHub';
import IconInstagram from './IconInstagram';

export default function Socials() {
  return <div className='socials'>
          <IconLinkedin/>
          <IconGitHub/>
          {/*<IconInstagram/>*/}
        </div>;
}
